import { Skeleton } from "antd";
import React, { useState } from "react";
import styles from "./index.module.scss";

export default function ImageLoading({ image }) {
  const [loading, setLoading] = useState(true);

  if (!image) return null;

  return (
    <>
      {loading && (
        <Skeleton.Image
          active
          className={styles.imageLoadingSkeleton}
          size="small"
        />
      )}
      <img
        src={image}
        alt="announcement"
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
        className={styles.imageLoadingImg}
        style={{ display: loading ? "none" : "block" }}
      />
    </>
  );
}
